import CategoryRepository from "./CategoryRepository";
import CategoryTreeRepository from "./CategoryTreeRepository"
import PlaceRepository from "./PlaceRepository"


const repositories = {
  categories: CategoryRepository,
  categoryTree: CategoryTreeRepository,
  places: PlaceRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
